<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible">
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
               label-width="130px">
            <el-form-item label="工号" prop="username">
                <el-input clearable v-model="dataForm.username" @change="changeUsername" :disabled="dataForm.id ? true : false"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="xm">
                <el-input clearable v-model="dataForm.xm" :disabled="dataForm.id ? true : false"></el-input>
            </el-form-item>
            <el-form-item label="组织单元全称" prop="zzdyqc">
                <el-select v-model="dataForm.zzdyqc" filterable @change="selectChangedZzdyqc" placeholder="请选择组织单元全称" style="width: 100%;">
                    <el-option
                            v-for="item in depts"
                            :key="item.bmid"
                            :label="item.bmmc"
                            :value="item.bmid">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="大队班组" prop="ddbz">
                <el-select v-model="dataForm.ddbz" placeholder="请选择大队班组" filterable clearable style="width: 100%;">
                    <el-option
                            v-for="item in childDepts"
                            :key="item.bmid"
                            :label="item.bmmc"
                            :value="item.bmid">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="岗位" prop="gwid">
                <el-select v-model="dataForm.gwid" @change="selectChangedGw" filterable clearable placeholder="请选择岗位" style="width: 100%;">
                  <el-option
                          v-for="item in gws"
                          :key="item.ID"
                          :label="item.GWMC"
                          :value="item.ID">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="来源" prop="ly">
                <el-input clearable v-model="dataForm.ly" ></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="sfzhm">
                <el-input clearable v-model="dataForm.sfzhm" ></el-input>
            </el-form-item>
            <el-form-item label="银行账号" prop="yhzh">
                <el-input clearable v-model="dataForm.yhzh" ></el-input>
            </el-form-item>
            <el-form-item label="缴金性质" prop="jjxz">
                <el-select v-model="dataForm.jjxz" placeholder="请选择缴金性质" style="width: 100%;" >
                    <el-option
                      v-for="list in dictionaryData.djjxz"
                      :label="list.mc"
                      :value="list.dm"
                    ></el-option>
                  </el-select>
            </el-form-item>
            <el-form-item label="用工性质" prop="ygxz">
                <el-select v-model="dataForm.ygxz" placeholder="请选择用工性质" style="width: 100%;" >
                  <el-option
                    v-for="list in dictionaryData.dygxz"
                    :label="list.mc"
                    :value="list.dm"
                  ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否工会会员" prop="ghhy">
                <el-select
                  v-model="dataForm.ghhy"
                  placeholder="请选择"
                  style="float: left"
                >
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="2"></el-option>
                </el-select>
              </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
      </span>
    </el-dialog>
  </template>
  
  <script>
    export default {
      data () {
        return {
          visible: false,
          dataForm: {
            id: '',
            userid: '',
            username: '',
            xm: '',
            zzdyqc: '',
            ddbz: '',
            gwid: '',
            gw: '',
            ly: '',
            sfzhm: '',
            yhzh: '',
            jjxz: '',
            ygxz: '',
            jrgsrq: '',
            month: '',
            ghhy: ''
          },
          dataRule: {
            zzdyqc: [
              {required: true, message: '组织单元全称不能为空', trigger: 'blur'}
            ],
            jjxz: [
              {required: true, message: '缴金性质不能为空', trigger: 'blur'}
            ],
            ygxz: [
              {required: true, message: '用工性质不能为空', trigger: 'blur'}
            ]
          },
          depts: [],
          childDepts: [],
          gws: [],
          dictionaryData: []
        }
      },
      methods: {
        init (val) {
            console.log("页面传入参数：",val)
            console.log("当前表单参数：",this.dataForm)
            this.dataForm.id = val.id
            this.dataForm.month = val.month
            this.visible = true
            this.$nextTick(() => {
            this.$refs['dataForm'].resetFields()
            this.getDepts()
            this.findDictionary()
            if(this.dataForm.id) {
                this.$http({
                    url: '/bjba/gzkquser/info/'+this.dataForm.id,
                    method: 'get'
                    }).then(({data}) => {
                        this.dataForm = data.data
                        this.getchildDepts(this.dataForm.zzdyqc)
                        this.getGw(this.dataForm.zzdyqc)
                    })
                }
            })
        },
        // 表单提交
        dataFormSubmit () {
          this.$refs['dataForm'].validate((valid) => {
            if (valid) {
                console.log("要保存的表单数据为：",this.dataForm)
                this.$http({
                    url: `/bjba/gzkquser/`+(this.dataForm.id?'update':'save'),
                    method: 'post',
                    data: this.dataForm
                }).then(({data}) => {
                    if (data && data.code === 200) {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500
                    })
                    this.visible = false
                    this.$emit('refreshDataList')
                    } else if(data && data.code === 500) {
                    this.$message({
                        message: data.message,
                        type: 'error',
                        duration: 1500
                    })
                    }
                }).catch(() => {
                    this.$message({
                        message: '操作失败',
                        type: 'error',
                        duration: 1500
                    })
                })
            }
          })
        },
        getDepts(){
            this.$request.get('/bjba/kqtj/getFirstMentForUser',{
                params: {
                    userid:this.$store.getters.username
                }
            }).then(res => {
                this.depts = res.data
                if(this.depts && this.depts[0]) {
                    var zzdyqc = this.$store.getters.user.zzdyqc;
                    if(zzdyqc){
                        if(zzdyqc != this.CONST_ZN_BM) {
                            var zw = this.$store.getters.user.zw;
                            if(zw) {
                                if(zw=='01'||zw=='02'||zw=='03') {
                                    this.dataForm.zzdyqc = this.depts[0].bmid
                                    this.getchildDepts(this.dataForm.zzdyqc)
                                    this.getGw(this.dataForm.zzdyqc)
                                }
                            }
                        }
                    }
                }
                this.getGw(this.dataForm.zzdyqc)
            })
        },
        selectChangedZzdyqc(value){
            this.dataForm.ddbz = ''
            this.dataForm.gwid = ''
            this.dataForm.gw = ''
            this.getchildDepts(value)
            this.getGw(value)
        },
        getchildDepts(value) {
            this.childDepts = []
            this.$request({
                method: 'get',
                url: '/bjba/kqtj/getMentForUser2',
                params: {
                    fbmid: value,
                    userid:this.$store.getters.username
                }
            }).then((response) => {
                this.childDepts = response.data;
                var zzdyqc = this.$store.getters.user.zzdyqc;
                if(zzdyqc){
                    if(zzdyqc != this.CONST_ZN_BM) {
                        var zw = this.$store.getters.user.zw;
                        if(zw) {
                            if(zw=='02'||zw=='03') {
                                if(this.childDepts[0]) {
                                    this.dataForm.ddbz = this.childDepts[0].bmid
                                }
                            }
                        }
                    }
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        getGw(val) {
            console.log('获取岗位信息：',val)
            console.log("部门信息为：",this.depts)
            let that = this;
            let ssdd
            for (var i = 0; i < this.depts.length; i++) {
                if (this.depts[i].bmid == val) {
                    ssdd = this.depts[i].bmmc;
                }
            }
            this.$request
                .get("/bjba/gwgl/all", {
                    params: {'ssdd':ssdd}
                })
                .then((res) => {
                    console.log("gws:",res.data.data)
                    that.gws = res.data.data;
                });
        },
        selectChangedGw(val) {
            console.log("选择完岗位信息获取到的值为：",val)
            for (var i = 0; i < this.gws.length; i++) {
                if (this.gws[i].ID == val) {
                    this.dataForm.gw = this.gws[i].GWMC;
                }
            }
        },
        findDictionary() {
            this.$request({
                method: "get",
                url: "/bjba/yhgl/findDictionary",
            })
            .then((response) => {
                console.log("map:", response.data);
                this.dictionaryData = response.data;
            })
            .catch((err) => {
                console.log(err);
            });
        },
        changeUsername(e) {
            this.$request.get('/bjba/gzkquser/findUserInfo',{
                params: {
                    username: e
                }
            }).then(res => {
                console.log("获取到的用户信息：",res);
                if (res.status == 200 && res.data.data.length != 0) {
                    var userInfo = res.data.data[0]
                    this.dataForm.userid = userInfo.id
                    this.dataForm.username = userInfo.username
                    this.dataForm.xm = userInfo.xm
                    this.dataForm.zzdyqc = userInfo.zzdyqc
                    this.dataForm.ddbz = userInfo.ddbz
                    this.dataForm.gwid = userInfo.gwid
                    this.dataForm.gw = userInfo.gw
                    this.dataForm.ly = userInfo.ly
                    this.dataForm.sfzhm = userInfo.sfzhm
                    this.dataForm.yhzh = userInfo.yhzh
                    this.dataForm.jjxz = userInfo.jjxz
                    this.dataForm.ygxz = userInfo.ygxz
                    this.dataForm.jrgsrq = userInfo.jrgsrq
                    this.dataForm.ghhy = userInfo.ghhy
                    this.getchildDepts(this.dataForm.zzdyqc)
                    this.getGw(this.dataForm.zzdyqc)
                }
            });
        }
      }
    }
  </script>
  